import { useQuery } from '@tanstack/react-query'
import { teamContentPagesApi } from '../api/teamContentPages'
import type { TeamContentPageIndex, TeamContentPageShow } from '../types/teamContentPage.types'

export const TEAM_CONTENT_PAGES_QUERY_KEY = 'teamContentPages'

// Hook to fetch all content pages for a team
export const useTeamContentPages = (teamId?: string, subdomain?: string) => {
  return useQuery<TeamContentPageIndex[], Error>({
    queryKey: [TEAM_CONTENT_PAGES_QUERY_KEY, teamId || subdomain],
    queryFn: async () => {
      if (teamId) {
        return teamContentPagesApi.getContentPages(teamId)
      } else if (subdomain) {
        return teamContentPagesApi.getContentPagesBySubdomain(subdomain)
      }
      throw new Error('Either teamId or subdomain must be provided')
    },
    enabled: !!(teamId || subdomain),
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

// Hook to fetch a specific content page
export const useTeamContentPage = (
  teamId?: string, 
  subdomain?: string, 
  slug?: string
) => {
  return useQuery<TeamContentPageShow, Error>({
    queryKey: [TEAM_CONTENT_PAGES_QUERY_KEY, teamId || subdomain, slug],
    queryFn: async () => {
      if (!slug) throw new Error('Slug is required')
      
      if (teamId) {
        return teamContentPagesApi.getContentPage(teamId, slug)
      } else if (subdomain) {
        return teamContentPagesApi.getContentPageBySubdomain(subdomain, slug)
      }
      throw new Error('Either teamId or subdomain must be provided')
    },
    enabled: !!(slug && (teamId || subdomain)),
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}